import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { ICategory } from '../../interfaces/ICategory';
import { ICall } from '../../interfaces/ICall';

const apiUrl = Globals.apiPath + '/calls';

export default class CallsService {
  constructor() {}

  static async getAll(
    restaurantId: number,
    branchId: number
  ): Promise<ICall[]> {
    let res = await axios.get<ICall[]>(
      `${apiUrl}?r=${restaurantId}&b=${branchId}`
    );
    return res.data;
  }

  async getById(id: number): Promise<ICall> {
    let res = await axios.get<ICall>(`${apiUrl}/${id}`);
    return res.data;
  }

  async create(call: ICall): Promise<ICall> {
    let res = await axios.post<ICall>(apiUrl, call);
    return res.data;
  }

  async view(call: ICall): Promise<ICall> {
    let res = await axios.post<ICall>(`${apiUrl}/${call.id}/view`);
    return res.data;
  }

  static async confirm(call: ICall): Promise<ICall> {
    let res = await axios.post<ICall>(`${apiUrl}/${call.id}/confirm`);
    return res.data;
  }
}
